<div class="p-6 lg:p-8">

  <!-- Breadcrumb + page title (back path to the Cloud overview) -->
  <div class="mb-5">
    <nav class="mb-2 flex items-center gap-1.5 text-xs" aria-label="Breadcrumb">
      <a
        routerLink="/cloud"
        class="rounded font-medium text-slate-500 transition-colors hover:text-violet-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400"
      >Cloud</a>
      <lucide-icon name="chevron-right" [size]="12" class="text-slate-300" [strokeWidth]="2"></lucide-icon>
      <span class="font-medium text-slate-500">AWS</span>
      <!-- Inherited account scope (shown when more than one AWS account is connected) -->
      <ng-container *ngIf="showAccount">
        <lucide-icon name="chevron-right" [size]="12" class="text-slate-300" [strokeWidth]="2"></lucide-icon>
        <span class="font-mono font-medium text-slate-500" [title]="'AWS account ' + account">{{ account }}</span>
      </ng-container>
      <lucide-icon name="chevron-right" [size]="12" class="text-slate-300" [strokeWidth]="2"></lucide-icon>
      <span class="font-medium text-slate-600">{{ title }}</span>
    </nav>

    <div class="flex items-center gap-2.5">
      <a
        routerLink="/cloud"
        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400"
        aria-label="Back to Cloud overview"
      >
        <lucide-icon name="arrow-left" [size]="16" [strokeWidth]="2"></lucide-icon>
      </a>
      <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-slate-100">
        <lucide-icon [name]="icon" [size]="18" class="text-slate-600" [strokeWidth]="1.75"></lucide-icon>
      </div>
      <h1 class="text-xl font-semibold text-slate-900">{{ title }}</h1>

      <!-- Region selector — scopes the detail data; only when >1 region enabled -->
      <div *ngIf="showRegionSwitcher" class="ml-auto flex items-center gap-1.5">
        <lucide-icon name="map-pin" [size]="13" class="text-slate-400" [strokeWidth]="1.75"></lucide-icon>
        <select
          [ngModel]="scope"
          (ngModelChange)="onScopeChange($event)"
          aria-label="Region"
          class="rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-medium text-slate-800 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-200"
        >
          <option [value]="ALL_REGIONS">All enabled regions</option>
          <option *ngFor="let r of enabledRegions" [value]="r">{{ r }}</option>
        </select>
      </div>

      <!-- Manual refresh (bypass cache + reload the page's data) -->
      <button
        type="button"
        (click)="refresh()"
        [disabled]="refreshing"
        class="flex flex-shrink-0 items-center gap-1.5 rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs font-medium text-slate-500 transition-colors hover:border-slate-300 hover:bg-slate-50 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 disabled:cursor-not-allowed disabled:opacity-60"
        [class.ml-auto]="!showRegionSwitcher"
        aria-label="Refresh data"
      >
        <lucide-icon name="refresh-cw" [size]="13" [strokeWidth]="2" [class.animate-spin]="refreshing"></lucide-icon>
        {{ refreshing ? 'Refreshing…' : 'Refresh' }}
      </button>
    </div>
  </div>

  <!-- Detail content — the routed service detail component renders here -->
  <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
    <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"></router-outlet>
  </div>

</div>
